<script lang="ts">
  import type { Writable } from "svelte/store";
  import TextNew from "../TextNew.svelte";
  import NumberBadge from "../data-display/NumberBadge.svelte";
  import type {
    DropdownMenuAttributes,
    DropdownMenuTriggerAttributes,
    MenuParams,
  } from "../dropdown-menu/create";
  import ArrowTooltip from "../tooltips/ArrowTooltip.svelte";
  import HeaderCell, { type Edge } from "./HeaderCell.svelte";
  import type { Action } from "svelte/action";
  import FilterMenu, {
    type FilterMenuItemDetails,
    type ToggleMode,
  } from "../dropdown-menu/FilterMenu.svelte";

  export let triggerAttrs: DropdownMenuTriggerAttributes;
  export let menuAttrs: DropdownMenuAttributes;
  export let triggerElement: HTMLElement | null = null;
  export let badgeElement: Writable<HTMLElement | null>;
  export let filterCount = 0;
  export let isHintTooltipVisible = false;
  export let isFilterMenuOpen = false;
  export let colWidth = 0;
  export let stickyLeft = 0;
  export let filterQueryParam: string;
  export let filterMenuAction: Action<HTMLElement, MenuParams, Record<never, any>>;
  export let filterMenuItems: FilterMenuItemDetails[] | undefined;
  export let edge: Edge = "middle";
  export let toggleMode: ToggleMode = "exclusive";
  export let shadow = false;
  export let zIndex = 2;

  const filterMenuOptions: MenuParams = {
    strategy: "absolute",
    placement: "bottom-start",
    closeOnClickOutside: true,
  };
</script>

<HeaderCell
  {shadow}
  {edge}
  {...triggerAttrs}
  --sticky-top="0"
  --sticky-left="{stickyLeft}px"
  --z-index={zIndex}
  --hover-color="var(--rk-neutral-4)"
  --color="var(--rk-text-transparency-dark)"
  --cursor="pointer"
  on:click
  bind:divElement={triggerElement}
  bind:colWidth
>
  <TextNew font="ocr" size="m" --rk-text-color="currentColor" --whitespace="nowrap">
    <slot />
  </TextNew>
  {#if filterCount > 0}
    <NumberBadge value={filterCount} bind:containerElement={$badgeElement} />
  {/if}
</HeaderCell>

<ArrowTooltip open={isHintTooltipVisible} anchorElement={badgeElement}>
  <TextNew size="xs" --rk-text-color="var(--rk-text-light)">filter applied</TextNew>
  <TextNew size="xs" --rk-text-color="var(--rk-text-transparency-light)">
    left click to edit
  </TextNew>
</ArrowTooltip>

<FilterMenu
  {filterQueryParam}
  isOpen={isFilterMenuOpen}
  {menuAttrs}
  action={filterMenuAction}
  menuOptions={filterMenuOptions}
  items={filterMenuItems}
  {toggleMode}
/>
